// extracted by mini-css-extract-plugin
export default {"container":"DE-z"};